export default {
  brandpartners: {
    subtitle: "OUR PARTNERS",

    title1: "Trusted by",
    title2: "Leading Food Brands",

    desc:
      "We collaborate with trusted suppliers and brands to ensure consistent quality and reliable sourcing.",

    cta: "Become a Partner",
  },
};